<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="back">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">User profile</p>
            <h1 class="page-title">ユーザー編集</h1>
            <p class="page-copy">
              基本情報、所属、権限、セキュリティ設定をこの画面でまとめて更新します。
              重要項目を先に、補足情報を後ろに分けて見通しを整えています。
            </p>
          </div>
          <div class="page-badge">
            <span class="page-badge__label">User ID</span>
            <span class="page-badge__value">{{ user_id }}</span>
          </div>
        </div>

        <form id="form" v-on:submit.prevent="dummy">
          <div class="editor-grid">
            <section class="profile-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Profile image</p>
                    <h2 class="section-title">プロフィール</h2>
                  </div>
                </div>

                <div class="avatar-layout">
                  <div class="avatar-frame">
                    <img :src="user.image" class="user-avatar" />
                  </div>
                  <div class="avatar-upload">
                    <label class="form-label">画像アップロード</label>
                    <input type="file" class="form-control form-control--file" v-on:change="fileSelected" />
                    <button v-if="fileSetted == true" v-on:click="fileUpload" class="btn-primary mt-2">画像をアップロード</button>
                  </div>
                </div>
              </div>

              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Main fields</p>
                    <h2 class="section-title">基本情報</h2>
                  </div>
                </div>

                <div class="field-grid field-grid--two">
                  <div class="form-group form-group--full">
                    <label class="form-label">メールアドレス</label>
                    <div class="form-static-card">
                      <span class="form-static">{{ email }}</span>
                      <span class="form-static-note">ログインに使うため、この画面では変更しません。</span>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="form-label">ID</label>
                    <input v-model="user_identifier" type="text" class="form-control" required />
                  </div>

                  <div class="form-group">
                    <label class="form-label">氏名</label>
                    <input v-model="name" type="text" class="form-control" required />
                  </div>

                  <div class="form-group">
                    <label class="form-label">生年月日</label>
                    <input v-model="birthday" type="date" pattern="yyyy-mm-dd" class="form-control" required />
                  </div>

                  <div class="form-group">
                    <label class="form-label">登録日</label>
                    <input v-model="joinday" type="date" pattern="yyyy-mm-dd" class="form-control" required />
                  </div>
                </div>
              </div>
            </section>

            <section class="detail-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Organization</p>
                    <h2 class="section-title">所属と権限</h2>
                  </div>
                </div>

                <div class="field-grid">
                  <div class="form-group">
                    <label class="form-label" for="teamSelect">チーム（部署）</label>
                    <select id="teamSelect" v-model="team_id" class="form-control">
                      <option v-for="team in teams" :key="team.id" :value="team.id">{{ team.display_name }}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label class="form-label" for="userTypeSelect">ユーザータイプ</label>
                    <select id="userTypeSelect" v-model="user_type" class="form-control">
                      <option v-for="ut in user_types" :key="ut.id" :value="ut.id">{{ ut.name }}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label class="form-label">自己紹介</label>
                    <textarea v-model="self_introduction" class="form-control form-control--textarea"></textarea>
                  </div>

                  <div class="form-group">
                    <label class="form-label">キャリアサマリ</label>
                    <textarea v-model="career_summary" class="form-control form-control--textarea"></textarea>
                  </div>
                </div>
              </div>

              <div class="section-card security-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Security</p>
                    <h2 class="section-title">パスワード更新</h2>
                  </div>
                  <button type="button" v-on:click="ui_open" class="btn-secondary">更新フォームを開く</button>
                </div>

                <p class="section-note">
                  パスワードは通常のプロフィール更新と分けて扱います。必要なときだけ展開してください。
                </p>

                <div v-if="password_change_ui==true" class="password-fields">
                  <div class="field-grid">
                    <div class="form-group">
                      <label class="form-label">新しいパスワード</label>
                      <input type="password" v-model="password" ref="password_textbox" class="form-control">
                    </div>

                    <div class="form-group">
                      <label class="form-label">新しいパスワード（確認）</label>
                      <input type="password" v-model="password_confirm" class="form-control">
                    </div>

                    <div class="form-group">
                      <button type="button" v-on:click="update_password" class="btn-primary">パスワード更新</button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="form-actions">
            <button type="button" v-on:click="update" class="btn-primary">更新</button>
            <button type="button" v-on:click="delete_user" class="btn-danger">削除</button>
            <button type="button" v-on:click="back" class="btn-secondary">戻る</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import {useRoute} from 'vue-router';
import store from "@/store";

const NORMAL_USER_TYPE = '1'
const SUPER_USER_TYPE = '2'
const NON_USER_TYPE = '3'

export default {
  data: function () {
    return {
      user_id: "",
      user: {},
      email: "",
      name: "",
      user_identifier: "",
      birthday: "",
      joinday: "",
      team_id: "",
      self_introduction: "",
      career_summary: "",
      fileInfo: '',
      fileSetted: false,
      password_change_ui: false,
      old_password: "",
      password: "",
      password_confirm: "",
      teams: [],
      user_type: NORMAL_USER_TYPE,
      user_types: [{ id: NORMAL_USER_TYPE, name: "一般ユーザー" }
                    , { id: SUPER_USER_TYPE, name: "管理者" }
                    , { id: NON_USER_TYPE, name: "お知らせ投稿用" } ],
    }
  },
  async mounted() {
    const route = useRoute()
    this.user_id = route.params.user_id;
    this.get();
    this.fetchTeams();
  },
  methods: {
    dummy: function () {
    },
    get: function () {
      axios.get("/user", {params: {user_id: this.user_id}}).then((response) => {
        this.user = response.data.user
        this.name = this.user.name
        this.email = this.user.email
        this.user_identifier = this.user.user_identifier
        this.birthday = this.user.birthday
        this.joinday = this.user.joinday
        this.self_introduction = this.user.self_introduction
        this.career_summary = this.user.career_summary
        this.team_id = this.user.tenant_team_id
        this.is_superuser = this.user.is_superuser
        this.is_nonuser = this.user.is_nonuser

        if (this.user.is_nonuser) {
          this.user_type = NON_USER_TYPE
        } else if (this.user.is_superuser) {
          this.user_type = SUPER_USER_TYPE
        }
      });
    },
    fetchTeams: function () {
      axios.get("/teams").then((response) => {
        this.teams = response.data
      });
    },
    update: function () {
      let nodes = document.querySelectorAll(`#form :invalid`)
      if (nodes.length > 0) {
        return
      }

      var is_superuser = false;
      var is_nonuser = false;
      if (this.user_type == NON_USER_TYPE) {
        is_nonuser =true;
      } else if (this.user_type == SUPER_USER_TYPE) {
        is_superuser = true;
      }

      const data = {
        user_id: this.user_id,
        name: this.name,
        user_identifier: this.user_identifier,
        birthday: this.birthday,
        joinday: this.joinday,
        tenant_team_id: this.team_id == undefined ? null : String(this.team_id),
        self_introduction: this.self_introduction == null ? '' : this.self_introduction,
        career_summary: this.career_summary == null ? '' : this.career_summary,
        is_superuser: is_superuser,
        is_nonuser: is_nonuser,
      };

      axios.post("/user_info_create_update", data)
        .then((res) => {
          router.push("/users");
        })
        .catch((error) => {
          alert(error.response.data.detail);
        });
    },
    delete_user: function() {
      axios.get("/user_delete", {params: {user_id: this.user_id}}).then((res) => {
        router.push("/users")
      })
    },
    fileSelected: function (event) {
      this.fileInfo = event.target.files[0];
      this.fileSetted = true
    },
    fileUpload: function () {
      const formData = new FormData()
      formData.append('file', this.fileInfo)
      axios.post('/user_image', formData, {params: {user_id: this.user_id}}).then(response => {
        router.go(0)
      });
    },
    back: function () {
      router.push("/users")
    },
    ui_open: function () {
      this.password_change_ui = true;
    },
    update_password: function () {
      if (this.password === "") {
        alert("パスワードを入力してください");
        return;
      }
      if (this.password !== this.password_confirm) {
        alert("パスワードが一致しません");
        return;
      }
      const data = {
        user_id: this.user_id,
        old_password: '',
        password: this.password,
        password_confirm: this.password_confirm,
      };
      axios.post("/user_password_update", data).then((res) => {
        router.go(0)
      })
    },
    logout: function () {
      store.dispatch("logout")
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 1180px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15,23,42,0.08);
  padding: 32px 40px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
}

.page-kicker {
  margin: 0 0 8px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.page-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.page-copy {
  max-width: 58ch;
  margin: 12px 0 0;
  color: #64748B;
  font-size: 0.95rem;
  line-height: 1.8;
}

.page-badge {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.page-badge__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748B;
}

.page-badge__value {
  font-size: 1rem;
  font-weight: 700;
  color: #0F172A;
}

.editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
  gap: 24px;
  align-items: start;
}

.profile-panel,
.detail-panel {
  display: grid;
  gap: 20px;
}

.section-card {
  padding: 20px;
  border-radius: 18px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%);
  border: 1px solid #E2E8F0;
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.section-kicker {
  margin: 0 0 6px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.section-title {
  margin: 0;
  font-size: 1.08rem;
  font-weight: 700;
  color: #1E293B;
}

.section-note {
  margin: 0 0 16px;
  color: #64748B;
  font-size: 0.9rem;
  line-height: 1.7;
}

.field-grid {
  display: grid;
  gap: 16px;
}

.field-grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.form-group { margin-bottom: 0; }
.form-group--full { grid-column: 1 / -1; }

.form-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
}

.form-control {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #CBD5E1;
  font-size: 0.9rem;
  background: #FFF;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.12);
}

.form-control--textarea {
  min-height: 120px;
  resize: vertical;
}

.form-control--file {
  background: #F8FAFC;
  padding: 10px 12px;
}

.form-static-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.form-static {
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1E293B;
}

.form-static-note {
  font-size: 0.8rem;
  color: #64748B;
}

.avatar-layout {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.avatar-frame {
  padding: 10px;
  border-radius: 18px;
  background: linear-gradient(180deg, #EFF6FF 0%, #F8FAFC 100%);
  border: 1px solid #DBEAFE;
}

.user-avatar {
  width: 120px;
  height: 160px;
  object-fit: cover;
  border-radius: 12px;
  display: block;
  border: 1.5px solid #E2E8F0;
  background: #FFF;
}

.avatar-upload {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.password-fields {
  margin-top: 12px;
  padding-top: 16px;
  border-top: 1px solid #E2E8F0;
}

.mt-2 { margin-top: 8px; }

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding-top: 20px;
  border-top: 1px solid #E2E8F0;
  margin-top: 28px;
}

.btn-primary {
  padding: 10px 24px; border-radius: 12px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-primary:hover { background: #2563EB; transform: translateY(-1px); }

.btn-danger {
  padding: 10px 24px; border-radius: 12px; border: none;
  background: #EF4444; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-danger:hover { background: #DC2626; transform: translateY(-1px); }

.btn-secondary {
  padding: 10px 24px; border-radius: 12px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; transform: translateY(-1px); }

@media (max-width: 900px) {
  .page-head,
  .section-head,
  .avatar-layout {
    flex-direction: column;
  }

  .editor-grid,
  .field-grid--two {
    grid-template-columns: 1fr;
  }

  .page-badge {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .top-header {
    padding: 0 16px;
  }

  .main-content {
    padding: 24px 14px 60px;
  }

  .white-card {
    padding: 22px 18px;
  }

  .section-card {
    padding: 16px;
  }

  .form-actions {
    justify-content: stretch;
  }

  .form-actions > * {
    width: 100%;
  }
}
</style>
